import { COGNITO_CONFIG } from '../utils/authConfig';
import { logout } from '../auth/amplifySetup';
class ApiError extends Error {
    constructor(message, { status, code, details, requestId } = {}) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.details = details;
        this.requestId = requestId;
    }
}

const apiClient = async (endpoint, options = {}) => {
    const token = localStorage.getItem('accessToken');

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
        ...options,
        headers,
    };

    // Automatically stringify body if it's an object and content-type is json
    if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
        config.body = JSON.stringify(options.body);
    }

    try {
        // Ensure endpoint starts with / for consistency
        const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
        const fullUrl = `${COGNITO_CONFIG.apiBaseUrl}${cleanEndpoint}`;

        // Log request details for debugging
        console.log(`[API] ${options.method || 'GET'} ${cleanEndpoint}`);
        if (options.body) {
            console.log(`[API] Body:`, options.body);
        }

        const response = await fetch(fullUrl, config);

        const parseJsonSafe = async () => {
            const raw = await response.text();
            if (!raw) return null;
            try {
                return JSON.parse(raw);
            } catch (e) {
                return raw;
            }
        };

        const payload = await parseJsonSafe();

        if (!response.ok) {
            const text = typeof payload === 'string' ? payload : JSON.stringify(payload);
            console.error(`API Error ${response.status} for ${endpoint}:`, text);

            let message = `API Error: ${response.status}`;
            let code;
            let details;
            let requestId;
            try {
                const json = typeof payload === 'string' ? JSON.parse(payload) : payload;
                if (json && typeof json === 'object' && json.ok === false && json.error) {
                    message = json.error.message || message;
                    code = json.error.code;
                    details = json.error.details;
                    requestId = json.error.requestId;
                } else if (typeof json === 'string') {
                    message = json;
                } else {
                    message = json.message || json.error || message;
                }
            } catch (e) {
                // Use raw text if not JSON
                if (text.length < 100) message += ` - ${text}`;
            }

            if (response.status === 401) {
                console.warn("Unauthorized access - clearing session");
                localStorage.removeItem('accessToken');
                logout().catch(console.error).finally(() => {
                    window.location.href = '/';
                });
            }

            throw new ApiError(message, { status: response.status, code, details, requestId });
        }

        if (response.status === 204) return null;
        if (payload && typeof payload === 'object' && payload.ok === true) {
            return payload.data;
        }
        return payload;
    } catch (error) {
        console.error('API Call Failed:', error);
        throw error;
    }
};

export default apiClient;
